import { Store } from 'redux';
import { actions as i18nActions, initI18n, Priority, Config } from '@altermaind/core/i18n';
import { DEFAULT_LANGUAGE, DEFAULT_LANGUAGE_CODE } from '../constants';
import { it, en } from '../locales';

/**
 * Configures i18n for the application.
 * Reads saved language from localStorage if available, otherwise uses defaults.
 *
 * @param {Store} store - The Redux store.
 * @param {string} [lang] - The language to set. If not provided, reads from localStorage or uses default.
 * @param {string} [langCode] - The language code to set. If not provided, reads from localStorage or uses default.
 */
const LANG_STORAGE_KEY = 'app_lang';
const LANG_CODE_STORAGE_KEY = 'app_langCode';

const configureI18n = (store: Store, lang?: string, langCode?: string) => {
  const savedLang = localStorage.getItem(LANG_STORAGE_KEY);
  const savedLangCode = localStorage.getItem(LANG_CODE_STORAGE_KEY);

  const finalLang = lang ?? savedLang ?? DEFAULT_LANGUAGE;
  const finalLangCode = langCode ?? savedLangCode ?? DEFAULT_LANGUAGE_CODE;

  const i18nConfig: Config = {
    defaultLanguage: {
      languageCode: finalLangCode,
      isRTL: false,
      languageTag: finalLang,
    },
    localePath: {
      it,
      en,
    },
    endPointI18n: '',
    endPointAuthorize: '',
    clientID: '',
    priority: Priority.Locale,
  };

  if (lang) {
    localStorage.setItem(LANG_STORAGE_KEY, finalLang);
    localStorage.setItem(LANG_CODE_STORAGE_KEY, finalLangCode);
  }

  initI18n(i18nConfig);
  store.dispatch(i18nActions.initializeTranslations());
};

export default configureI18n;
